import { FC } from 'react'
import { getCategoriesByIds } from '../store/module'
import useJobCategoryStore from '../store/store.jobCategory'
import ContainerCategoryGroup from './ContainerCategoryGroup'

interface IFSecondCategoriesProps {
  className?: string
}

const SecondCategories: FC<IFSecondCategoriesProps> = ({ className }) => {
  const jobCategoryStore = useJobCategoryStore()
  const { categories, idsByDepth, activeIds } = jobCategoryStore

  const selectedFirstCategoryId = activeIds[0]
  const selectedFirstCategory = selectedFirstCategoryId
    ? categories?.[selectedFirstCategoryId]
    : undefined

  const secondDepthIds = idsByDepth?.[2]
  const secondCategories =
    (selectedFirstCategoryId &&
      secondDepthIds &&
      getCategoriesByIds(secondDepthIds, categories).filter(
        (category) => category.parentId === selectedFirstCategoryId,
      )) ||
    []

  return (
    <ContainerCategoryGroup
      categories={secondCategories}
      parentCategory={selectedFirstCategory}
      className={className}
    />
  )
}

export default SecondCategories
